import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './styles';

export default function DefaultLayout({ children }) {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
